import * as core from '../../../../../../../core'

import { query } from './capacity-assessment-rubric-report-card.query'

export const RESOURCE = {
  payload: {
    alias: 'capacity-assessment-rubric.report-card',
    description: 'Shows the Capacity Assessment Rubric for a given Affiliate',
    name: 'Capacity Assessment Rubric Report Card',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
